import { createReducer, createSelector, on } from '@ngrx/store';
import { ProductCategoryType } from '@iota/iota-management-portal-v4-client';
import { IotaConfig, IotaConfigAttributeScope } from 'src/app/shared/constants-and-enums/iota-config';
import { isAttributeCategoryAvailable } from 'src/app/shared/utils/attribute-category.util';
import { LoadIotaConfig, LoadIotaConfigFailure, LoadIotaConfigSuccess } from '../actions/iota-config.actions';
import { AppState } from '../store';

export interface IotaConfigState {
    loading: boolean;
    loaded: boolean;
    error: any;
    iotaConfig: IotaConfig;
}

export const initialState: IotaConfigState = {
    loading: false,
    loaded: false,
    error: undefined,
    iotaConfig: undefined
};

export const iotaConfigReducer = createReducer(
    initialState,
    on(LoadIotaConfig, (state) => ({ ...state, loading: true })),
    on(LoadIotaConfigSuccess, (state, { iotaConfig }) => ({ ...state, loading: false, iotaConfig, loaded: true })),
    on(LoadIotaConfigFailure, (state, { error }) => ({ ...state, error, loading: false, loaded: false }))
);

export const iotaConfigState = (state: AppState) => state.iotaConfigState;
export const iotaConfigLoading = createSelector(iotaConfigState, ({ loading }) => loading);
export const iotaConfigLoaded = createSelector(iotaConfigState, ({ loaded }) => loaded);
export const iotaConfigError = createSelector(iotaConfigState, ({ error }) => error);

export const iotaConfigAttributesByScope = (scope: IotaConfigAttributeScope, productCategory?: ProductCategoryType) =>
    createSelector(
        iotaConfigState,
        ({ iotaConfig }) =>
            iotaConfig?.attributes
                ?.filter((attr) => attr?.scopes?.includes(scope))
                .filter((attr) => filterIgnoredAttributes(scope, attr.name))
                .filter((attr) => isAttributeCategoryAvailable(scope, attr.category, productCategory)) ?? []
    );
export const iotaConfigLocales = createSelector(iotaConfigState, ({ iotaConfig }) => iotaConfig?.locales ?? []);

export function filterIgnoredAttributes(scope: IotaConfigAttributeScope, attr: string) {
    return !IGNORED_ATTRIBUTES_BY_SCOPE[scope]?.includes(attr);
}

export const IGNORED_ATTRIBUTES_BY_SCOPE: { [K in IotaConfigAttributeScope]: string[] } = {
    ['COMPANY_REGISTRATION_PERIOD']: ['NAME', 'INTERNAL_NAME'],
    ['COMPANY']: [],
    ['PRODUCT']: [],
    ['SUB_PRODUCT']: []
};
